
const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About Us', href: '#about' },
    { name: 'Experiences', href: '#pick-your-own' },
    // { name: 'Heritage', href: '#heritage' },
    // { name: 'Boutique', href: '#boutique' },
    { name: 'Visit Us', href: '#interact-farmers' }
  ];

  const experiences = [
    { name: 'Pick Your Own', href: '#pick-your-own' },
    // { name: 'Be a Farmer', href: '#be-a-farmer' },
    { name: 'Rose Garden', href: '#rose-garden' },
    // { name: 'Fishing', href: '#fishing' },
    { name: 'Modern Farming', href: '#modern-farming' }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Farm Info */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
              Aroha Farm
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Experience organic living, natural farming, and the joy of growing together in harmony with nature.
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-green-400"></i>
                </div>
                <span className="text-gray-300">+91 9486335200</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-green-400"></i>
                </div>
                <span className="text-gray-300">kiwindian_nz@yahoo.com</span>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-line text-green-400"></i>
                </div>
                <span className="text-gray-300">
                  Kottaiyur village,
                  Yelagiri Hills<br />
                  Tirupattur District – 635853
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-300 hover:text-green-400 transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Experiences */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Experiences</h4>
            <ul className="space-y-2">
              {experiences.map((experience) => (
                <li key={experience.name}>
                  <button
                    onClick={() => scrollToSection(experience.href)}
                    className="text-gray-300 hover:text-green-400 transition-colors duration-300 cursor-pointer"
                  >
                    {experience.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Farm Hours & Map */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Visit Us</h4>
            <div className="space-y-4">
              <div>
                <h5 className="font-medium text-green-400 mb-2">Farm Hours</h5>
                <div className="text-gray-300 text-sm space-y-1">
                  <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
                  <p>Saturday - Sunday: 9:00 AM - 7:00 PM</p>
                  <p className="text-green-400">Open all days</p>
                </div>
              </div>

              <div>
                <h5 className="font-medium text-green-400 mb-2">Location</h5>
                <div className="bg-gray-800 rounded-lg p-3">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3893.748565385104!2d78.63929717507017!3d12.598815687683311!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3badaa8e5ac2c711%3A0x2d3482edb9f1f051!2sThrill%20Valley!5e0!3m2!1sen!2sin!4v1760943908091!5m2!1sen!2sin"
                    width="100%"
                    height="120"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="rounded"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} Aroha Farm — All Rights Reserved
            </div>
            <div className="flex items-center space-x-6">
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300"
              >
                Designed by Codemontis. Pvt. Ltd
              </a>
              <div className="flex space-x-4">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-instagram-line"></i>
                  </div>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-facebook-line"></i>
                  </div>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-youtube-line"></i>
                  </div>
                </a>
                <a href="https://whatsapp.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-whatsapp-line"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-8 right-8 w-12 h-12 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 z-40 cursor-pointer"
        title="Back to Top"
      >
        <div className="w-6 h-6 flex items-center justify-center mx-auto">
          <i className="ri-arrow-up-line text-lg"></i>
        </div>
      </button>
    </footer>
  );
};

export default Footer;
